import cn from 'classnames';
import NavItem from 'components/nav-item';
import Image from 'next/image';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

interface FilterButtonProps {
  filterName: string;
  handleToggleFilter: (filterName: string) => void;
  isSelected: boolean;
  additionalClassName?: string;
  size?: 'sm' | 'lg';
}

/**
 * Button for the hero filter component.
 * With memo, only the affected filter button will be re-rendered, if a button is updated,
 * reducing the overall rendering time.
 */
const HeroFilterButton: React.FC<FilterButtonProps> = memo(
  ({ filterName, handleToggleFilter, isSelected, size }) => {
    return (
      <NavItem
        data-test={`hero-filter-chip-${filterName}`}
        onClick={() => handleToggleFilter(filterName)}
        selected={isSelected}
        className="px-2 py-1 lg:justify-start lg:py-1.5"
      >
        <div
          className={cn(
            'flex flex-col items-center justify-center gap-1 lg:flex-row',
            size === 'sm' && 'flex-row!'
          )}
        >
          <div
            className={cn(
              'h-[48px] w-[48px] lg:h-[30px] lg:w-[30px]',
              size === 'sm' && 'h-[30px]! w-[30px]!'
            )}
          >
            <Image
              src={`/images/collection/hero-filter/hero_filter_${filterName}.png`}
              alt={filterName}
              width={96}
              height={96}
            />
          </div>
          <p className="text-xs lg:text-sm">
            <FormattedMessage id={`common:hero-filter:${filterName}`} />
          </p>
        </div>
      </NavItem>
    );
  }
);

HeroFilterButton.displayName = 'HeroFilterButton';

export default HeroFilterButton;
